import { ActionKeys } from "../_actions/constants/userConstants";

const initialState = {
  isLoading: false,
  isError: false,
  errorMessage: null,
  user: null
};

export default function userReducer(state, action) {
  state = state || initialState;

  switch (action.type) {
    case ActionKeys.REQUEST_USER_INFO:
      return {
        ...state,
        isLoading: true,
        isError: false
      };
    case ActionKeys.RECEIVE_USER_INFO:
      return {
        ...state,
        user: action.user,
        isLoading: false,
        isError: action.isError,
        errorMessage: action.errorMessage
      };
    default:
      return { ...state };
  }
}
